import { useContext, createContext } from "react";

type ResolveRef = (ref: string) => string;

export const AssetResolverContext = createContext<ResolveRef>((ref) => ref);

export function useAssetResolver(): ResolveRef {
  return useContext(AssetResolverContext);
}
